(function(){
  var $=function(s,c){return (c||document).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var overlay=$('[data-overlay]');

  /* ---------- drawers ---------- */
  function closeAll(){
    $$('[data-drawer].is-open').forEach(function(e){e.classList.remove('is-open');e.setAttribute('aria-hidden','true')});
    overlay&&overlay.classList.remove('is-on');document.body.classList.remove('no-scroll');
  }
  function openEl(id){
    var el=document.getElementById(id);if(!el)return;
    closeAll();el.classList.add('is-open');el.setAttribute('aria-hidden','false');
    overlay&&overlay.classList.add('is-on');document.body.classList.add('no-scroll');
    var i=$('input[type=search]',el);if(i)setTimeout(function(){i.focus()},120);
  }

  /* ---------- cart ---------- */
  function refreshCart(open){
    return fetch(root+'?sections=cart-drawer',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(j){
      var doc=new DOMParser().parseFromString(j['cart-drawer'],'text/html');
      var nd=$('[data-drawer-cart]',doc),d=$('#cart-drawer');
      if(nd&&d)d.innerHTML=nd.innerHTML;
      return fetch(root+'cart.js').then(function(r){return r.json()});
    }).then(function(c){
      $$('[data-cart-count]').forEach(function(e){e.textContent=c.item_count;e.hidden=!c.item_count});
      if(open)openEl('cart-drawer');
    });
  }
  function changeCart(key,qty){
    return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){
      if($('.cart-page')){location.reload();return}
      return refreshCart(false);
    });
  }

  document.addEventListener('click',function(e){
    var t=e.target,o=t.closest('[data-open]');
    if(o){
      if(o.dataset.open==='cart-drawer'&&!document.getElementById('cart-drawer'))return;
      e.preventDefault();openEl(o.dataset.open);return;
    }
    if(t.closest('[data-close]')||t===overlay){closeAll();return}
    var ch=t.closest('[data-cart-change]');
    if(ch){e.preventDefault();changeCart(ch.dataset.cartChange,parseInt(ch.dataset.qty,10));return}
    var m=t.closest('[data-qty-minus],[data-qty-plus]');
    if(m){
      var inp=$('[data-qty-input]',m.parentNode),v=parseInt(inp.value,10)||1;
      inp.value=Math.max(1,v+(m.hasAttribute('data-qty-plus')?1:-1));return;
    }
    var th=t.closest('[data-thumb]');
    if(th){showMedia(th.dataset.thumb)}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-ajax-add]');if(!f)return;
    e.preventDefault();
    var btn=$('[type=submit]',f),err=$('[data-form-error]',f);
    if(btn){btn.disabled=true;btn.classList.add('is-loading')}
    fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)})
      .then(function(r){return r.json()})
      .then(function(j){
        if(j.status){
          var msg=j.description||j.message||'Could not add to bag';
          if(err){err.textContent=msg;err.hidden=false}else alert(msg);
          return;
        }
        if(err)err.hidden=true;
        if(document.body.dataset.cartType==='page'||!document.getElementById('cart-drawer')){location.href=root+'cart';return}
        return refreshCart(true);
      })
      .catch(function(){f.submit()})
      .then(function(){if(btn){btn.classList.remove('is-loading');if(!btn.hasAttribute('data-add-btn')||btn.textContent.trim()===btn.dataset.add)btn.disabled=false}});
  });

  /* ---------- announcement rotator ---------- */
  $$('[data-rotator]').forEach(function(r){
    var m=$$('.announce__msg',r);if(m.length<2)return;var i=0;
    setInterval(function(){m[i].classList.remove('is-active');i=(i+1)%m.length;m[i].classList.add('is-active')},4500);
  });

  /* ---------- hero slider ---------- */
  $$('[data-slider]').forEach(function(s){
    var track=$('[data-track]',s),slides=$$('[data-slide]',s),dots=$$('[data-dot]',s),i=0,t;
    function go(n){i=(n+slides.length)%slides.length;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'})}
    var p=$('[data-prev]',s),n=$('[data-next]',s);
    p&&p.addEventListener('click',function(){go(i-1)});n&&n.addEventListener('click',function(){go(i+1)});
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k)})});
    track.addEventListener('scroll',function(){i=Math.round(track.scrollLeft/track.clientWidth);dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)})},{passive:true});
    var sp=parseInt(s.dataset.autoplay,10);
    function start(){if(sp&&slides.length>1)t=setInterval(function(){go(i+1)},sp*1000)}
    function stop(){clearInterval(t)}
    s.addEventListener('mouseenter',stop);s.addEventListener('mouseleave',start);s.addEventListener('touchstart',stop,{passive:true});start();
  });

  /* ---------- product page ---------- */
  function showMedia(id){
    $$('[data-media-id]').forEach(function(e){e.classList.toggle('is-active',e.dataset.mediaId===String(id))});
    $$('[data-thumb]').forEach(function(e){e.classList.toggle('is-active',e.dataset.thumb===String(id))});
  }
  $$('[data-product]').forEach(function(p){
    var js=$('[data-variants-json]',p);if(!js)return;
    var data=JSON.parse(js.textContent),idIn=$('[data-variant-id]',p),price=$('[data-price]',p),btn=$('[data-add-btn]',p),sku=$('[data-sku]',p);
    $$('.opt__input',p).forEach(function(inp){
      inp.addEventListener('change',function(){
        var sel=$$('fieldset[data-option-index]',p).map(function(f){var c=$('input:checked',f);return c&&c.value});
        $$('fieldset[data-option-index]',p).forEach(function(f){var c=$('input:checked',f),s=$('[data-opt-val]',f);if(c&&s)s.textContent=c.value});
        var v=data.filter(function(x){return x.options.every(function(val,k){return val===sel[k]})})[0];
        if(!v){btn.disabled=true;btn.textContent=btn.dataset.unavailable;return}
        idIn.value=v.id;
        if(price){price.classList.toggle('price--sale',v.onSale);price.innerHTML=(v.onSale?'<s class="price__compare">'+v.compare+'</s> ':'')+'<span class="price__now">'+v.price+'</span>'}
        btn.disabled=!v.available;btn.textContent=v.available?btn.dataset.add:btn.dataset.soldout;
        if(sku)sku.textContent=v.sku||'';
        if(v.media)showMedia(v.media);
        try{history.replaceState(null,'','?variant='+v.id)}catch(_){}
      });
    });
  });

  /* ---------- collection filters ---------- */
  var ff=$('[data-filter-form]');
  if(ff){
    var go=function(){ff.requestSubmit?ff.requestSubmit():ff.submit()};
    ff.addEventListener('change',go);
    ff.addEventListener('submit',function(){$$('input[type=number]',ff).forEach(function(i){if(!i.value)i.disabled=true})});
    $$('[data-auto-submit]').forEach(function(s){s.addEventListener('change',go)});
  }else{
    $$('[data-auto-submit]').forEach(function(s){s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.href=u.toString()})});
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recs]').forEach(function(el){
    if($('.card',el)||!el.dataset.url)return;
    fetch(el.dataset.url).then(function(r){return r.text()}).then(function(t){
      var n=$('[data-recs]',new DOMParser().parseFromString(t,'text/html'));
      if(n&&n.innerHTML.trim())el.innerHTML=n.innerHTML;
    }).catch(function(){});
  });
})();
